import WarningModal from "../../components-modals/WarningModal"
import OtherWarehouseGrid from "./OtherWarehouseGrid"

const OtherWarehousesModal = ({ showForm = false, setShowForm, url = '', headers = {}, data = [], addProduct }) => {

    const name = data[0]?.Descripcion_Corta

    return(
        <WarningModal
            open={showForm}
            width='w-auto'
            bgColor="bg-primarioMira"
            opacity='bg-opacity-75'
            isDefault={false}
        >

            <div className="pl-5 flex flex-col gap-2 pb-5">
                <h2 className="text-lg font-semibold text-white">Producto sin existencias en su bodega</h2>
                <p className="text-sm font-semibold text-grisMira">Seleccione {name} en alguna de estas bodegas:</p>
            </div>

            <OtherWarehouseGrid
                productos={data}
                addProduct={addProduct}
                setShowForm={setShowForm}
                url={url + '/inventario/enviar_sms_prod'}
                headers={headers}
            />
                <div className="mt-5 sm:mt-6 flex justify-between gap-5">
                    <button
                        type="button"
                        onClick={() => setShowForm(false)}
                        className="transition-colors duration-500 ease-in-out inline-flex w-full justify-center rounded-md border border-transparent bg-red-500 px-4 py-1 text-base font-medium text-white shadow-sm hover:bg-primarioMira border-2 hover:border-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2"
                    >
                        Salir
                    </button>
                </div>
        </WarningModal>
    )
}

export default OtherWarehousesModal